// 협업 도구 정의(칸반·협업테이블·위키) — CollabToolsPage(랜딩)·CollabViewPage(새창 임베드) 공용.
const W = 'width="20" height="20" style="fill:currentColor"';
export const COLLAB_TOOLS = [
  { key: 'deck', icon: '📋', label: '칸반', url: '/drive/apps/deck/',
    desc: '보드·리스트·카드로 업무를 추적하고 담당자·마감일·라벨을 관리합니다.',
    hdrSvg: `<svg viewBox="0 0 24 24" ${W}><path d="M4 5h4v14H4zm6 0h4v9h-4zm6 0h4v14h-4z"/></svg>` },
  { key: 'tables', icon: '🗂️', label: '협업테이블', url: '/drive/apps/tables/',
    desc: '행·열·뷰로 데이터를 정리하고 여러 명이 함께 입력·관리합니다.',
    hdrSvg: `<svg viewBox="0 0 24 24" ${W}><path d="M3 3h18v18H3V3zm2 2v4h6V5H5zm8 0v4h6V5h-6zM5 11v4h6v-4H5zm8 0v4h6v-4h-6zM5 17v2h6v-2H5zm8 0v2h6v-2h-6z"/></svg>` },
  { key: 'collectives', icon: '📖', label: '위키', url: '/drive/apps/collectives/',
    desc: '매뉴얼·회의록·문서를 페이지로 작성하고 팀 지식을 한곳에 모읍니다.',
    hdrSvg: `<svg viewBox="0 0 24 24" ${W}><path d="M18 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 4h5v8l-2.5-1.5L6 12V4z"/></svg>` },
  { key: 'forms', icon: '📝', label: '설문', url: '/drive/apps/forms/',
    desc: '설문·투표·신청서를 만들고 링크로 공유해 응답을 수집합니다.',
    hdrSvg: `<svg viewBox="0 0 24 24" ${W}><path d="M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM7 7h10v2H7zm0 4h10v2H7zm0 4h7v2H7z"/></svg>` },
  { key: 'notes', icon: '🗒️', label: '노트', url: '/drive/apps/notes/',
    desc: '메모와 할 일을 빠르게 작성하고 카테고리로 정리합니다.',
    hdrSvg: `<svg viewBox="0 0 24 24" ${W}><path d="M3 3h14l4 4v14H3V3zm2 2v14h14V8h-4V5H5zm2 6h10v2H7zm0 4h7v2H7z"/></svg>` },
];
